import { render, staticRenderFns } from "./ModerationModal.vue?vue&type=template&id=70cbe424&lang=pug&"
import script from "./ModerationModal.vue?vue&type=script&lang=js&"
export * from "./ModerationModal.vue?vue&type=script&lang=js&"
import style0 from "./ModerationModal.vue?vue&type=style&index=0&id=70cbe424&prod&lang=scss&"
import style1 from "./ModerationModal.vue?vue&type=style&index=1&id=70cbe424&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports